import styled from "styled-components";

export const MReferralCommissionSection = styled.div`
  width: 100%;

  padding: 16px;
  background: ${(p) => p.theme.COLORS.cardOpacity};
`;
